// extracted by mini-css-extract-plugin
export default {"wrapper":"Tooltip_wrapper__t4qz-","text":"Tooltip_text__cjhVd"};